module.exports = __webpack_public_path__ + "static/media/basics.90e23c61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/basics.jpg
// module id = 1308
// module chunks = 0